import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import Container from '../../components/Container';
import { Grid, Drawer } from '@material-ui/core';
import Typo from '../../components/CustomTypo'
import { GiftIcon, GoogleMapIcon } from '../../components/icons'
import { GoogleMap, LoadScript, Marker, InfoBox } from '@react-google-maps/api'
import CustomizedCircularProgress from '../../components/CircularProgress';
import DrawerCustom from '../../components/DrawerCustom';
import { LinkRouter } from '../../components/Link';
import { usage_type, dataUtil } from '../../wsclient/crmservices/dataUtil';
import InfiniteScroll from 'react-infinite-scroll-component';
const heightCover = 264
const heightDesc = 380
const heightMap = window.innerHeight-heightCover-heightDesc-80
const styles = theme => ({

    cover: {
        width: '100%',
        height: heightCover,
        objectFit: 'cover',
        position: 'relative',
    },
    owned_by: {
        marginLeft: theme.spacing(4),
        marginTop: theme.spacing(4),
        borderRadius: theme.spacing(10),
        padding: theme.spacing(1, 2, 1, 2),
        backgroundColor:'rgba(255,255,255,0.1)',
    },
    phone_number: {
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(4),
        borderRadius: theme.spacing(10),
        padding: theme.spacing(1, 2, 1, 2),
        backgroundColor:'rgba(255,255,255,0.1)',
    },
    name: {
        width: '100%',
        padding: theme.spacing(2),
        position: 'absolute',
        top: heightCover - theme.spacing(12),
        backgroundColor: 'rgba(0,0,0,0.1)',
    },
    description: {
        padding: theme.spacing(4),
        borderRadius: theme.spacing(2),
        margin: theme.spacing(4),
        backgroundColor: theme.palette.background.secondary,
        //height: heightDesc
    },
    cursor:{
        cursor: 'pointer'
    },
    content: {
        padding: theme.spacing(4),
        whiteSpace: 'pre-line',
    },
    card_circle: {
        width: 60,
        height: 60,
        borderRadius: 60,
        border: '1px solid',
        borderColor: theme.palette.border.primary,
        marginRight: 15,
        marginLeft: 15,
        marginTop: 10,
    },
    card_icon: {
        width: 45,
        height: 45,
        borderRadius: 45,
    }

});
const containerStyle = {
    width: '100%',
    height: heightMap
};
function PromotionDetailView(props) {
        const { classes, t, offer, showLoading, onShowCurrentLocation } = props;
        //console.log('offer=======', offer)
        return (
            <div>
                <DrawerCustom
                    open={props.open}
                    onClose={() => props.onClose()}
                    fullScreen
                    enableBack
                    children={showLoading || !offer ? <Grid xs={12} item container justify='center' alignItems='center'>
                                                            <CustomizedCircularProgress color="primary" />
                                                        </Grid> : 
                        <Grid item>
                            <OfferItemImage classes={classes} image={dataUtil.getImageByUsageTypePortal(offer.creatives, usage_type.offer_detail)} />
                            <Grid item className={classes.name} >
                                <Typo  variant='h3' color='onPrimary'>{offer.name ? offer.name : ""}</Typo>
                            </Grid>
                            
                            <Grid xs={12} item container>
                                {offer.owned_by && offer.owned_by.name&&<div className={classes.owned_by}>
                                    <Typo variant='body2' color='onPrimary'>{offer.owned_by.name}</Typo>
                                </div>}
                                {offer.phone_number&&<div className={classes.phone_number}>
                                    <Typo variant='body2' color='onPrimary' >{offer.phone_number}</Typo>
                                </div>}
                            </Grid>
                            
                            {(offer.short_description|| offer.performance_enabled)&& <Grid xs={12} item className={classes.description}>
                            <Typo variant='subtitle2' >{offer.short_description ? offer.short_description : ""}</Typo>
                                <Typo variant='body1' >{offer.long_description ? offer.long_description : ""}</Typo>
                            </Grid>}
            
                    </Grid>}
                />

            </div>

        );
}
function PerformanceOffer(props) {
    var { offer, classes } = props;
    var performance_data = offer.performance_data;
    // performance_data.target_purchases = 8;
    // performance_data.current_purchases = 3;
    // performance_data.type = 'PRODUCT';
    if (!offer.performance_enabled || !performance_data || performance_data.type!='PRODUCT' || performance_data.target_purchases == 0)
        return null;
    var rows = [];
    var row = [];
    for (let i = 0; i < performance_data.target_purchases; i++) {
        var card;
        if (i < performance_data.current_purchases && i < performance_data.target_purchases) {
            card = (
                <Grid item className={classes.card_circle} container alignItems='center' justify='center'>
                    <Grid item>
                        <GiftItem classes = {classes} image={dataUtil.getImageByUsageTypePortal(offer.creatives, usage_type.offer_detail)} />
                    </Grid>
                </Grid>
            );
        }else{
            card = (<Grid item className={classes.card_circle}/>)
        }
        if (i % 3 == 0) {
            row = [];
            rows.push(row);
        }
        row.push(card);
    }
    var uiRows = []
    for (var i = 0; i < rows.length; i++) {
        uiRows.push(<Grid key={i} direction='row' container justify='center'>{rows[i]}</Grid>);
    }
    return (
        <Grid xs={12} item container justify='center'>
            {uiRows}
        </Grid>
    )
}
function OfferItemImage(props) {
    const { classes, image } = props;
    if (image) {
        return <img src={image.url} className={classes.cover} />
    } else {
        return (
            <Grid xs={12} item className={classes.cover} alignItems='center' justify='center' container>
                <GiftIcon/>
            </Grid>
        )
    }
}
function GiftItem(props) {
    const { classes, image } = props;
    if (image) {
        return <img src={image.url} className={classes.card_icon} />
    } else {
        return (
                 <Grid item style={{marginRight:-8}}>
                    <GiftIcon className={classes.card_icon}/>
                 </Grid>
        )
    }
}
export default withStyles(styles)(withTranslation()(PromotionDetailView));